"use client"

import React from "react"

import CheckLoggedIn from "@/components/check-logged-in"
import { AuthGuardProvider } from "@/context/AuthGuardContext"
import { Toaster } from "@/components/pm-ui/ui/sonner"

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <AuthGuardProvider>
      <CheckLoggedIn />
      <Toaster />
      {children}
    </AuthGuardProvider>
  )
}
